// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d804d608","287":"9e51c3fa","453":"e20903e0","455":"65f04bde","977":"64a517d1"}[chunkId] + ".chunk.js";
};